enum APPLICATION_DOCUMENT_STATUSES_ENUM {
	PENDING = 'pending',
	UPLOADED = 'uploaded',
	APPROVED = 'approved',
	DECLINED = 'declined',
}

export default APPLICATION_DOCUMENT_STATUSES_ENUM;
